// src/components/MDNavBar.js
/**
 * Minimal branding strip used on *public* pages (landing, login, sign-up).
 *
 * Layout
 * ┌──────────────────────────────────────────────────────────────┐
 * │ [MD logos…]        ┆   electronRx word-mark + postal address │
 * └──────────────────────────────────────────────────────────────┘
 *
 * No interactivity – purely presentational – so we keep this file tiny and
 * wrap it in `React.memo` to avoid unnecessary re-renders.
 *
 * Props
 * @param {string} [className] – Tailwind utility classes merged into the root
 *        div. Lets parent pages make it `sticky` or change margins.
 */

import React from "react";
import { useTranslation } from "react-i18next";

import LangSwitcher from "../LangSwitcher";

/**
 * Branding-only nav bar shown when the user is **not** authenticated.
 *
 * @param {{ className?: string }} props
 */
function MDNavBar({ className = "" }) {
  const { t } = useTranslation();

  return (
    <div
      className={`safe-area-top safe-area-x bg-background flex items-center gap-4 w-full h-fit p-2 ${className}`}
    >
      <div className="flex items-center gap-4 w-full h-fit p-2">
        {/* Company mark + address ------------------------------------- */}
        <div className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 205 255"
            className="fill-black h-6 lg:h-8"
            aria-hidden="true"
          >
            <path
              stroke="#000"
              strokeWidth="5"
              d="M2.5 252.5v-120l25-50 25 50 25-50 25 50 25-50 25 50V2.5h50v250z"
            />
          </svg>
          <address className="flex flex-col not-italic text-[6px] leading-tight">
            <span>{t("company.name")}</span>
            <span>{t("company.address1")}</span>
            <span>{t("company.address2")}</span>
            <span>{t("company.address3")}</span>
          </address>
        </div>
      </div>
      <LangSwitcher />
    </div>
  );
}

export default React.memo(MDNavBar);
